import $ from "jquery";
import getConfig from "./config";

const config = getConfig();

const setupAnnouncements = async (options = {}, resize = () => {}) => {
    const announcements = config.masthead?.querySelector(
        ".site-header__announcements",
    );
    if (!announcements) {
        return;
    }

    try {
        await import("animate.css/animate.min.css");
        await import("owl.carousel/dist/assets/owl.carousel.min.css");
        await import("owl.carousel");

        $(announcements)
            .owlCarousel({
                items: 1,
                loop: true,
                margin: 0,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayTimeout: 5000,
                touchDrag: false,
                mouseDrag: false,
                animateOut: "animate__fadeOutUp",
                animateIn: "animate__fadeInUp",
                lazyLoad: false,
                ...options,
            })
            .on("resized.owl.carousel", resize);
    } catch (err) {
        console.error(err);
    }
};

export default setupAnnouncements;
